import React from 'react';
import { Box, Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { isRecordFound, useSelectedOrganizationData, useSelectedLocationData } from '../../hooks/data-hooks';

const useStyles = makeStyles({
    wrapText: {
        lineHeight: 1.25,
        textOverflow: 'ellipsis',
        display: '-webkit-box',
        WebkitLineClamp: 1,
        WebkitBoxOrient: 'vertical',
        overflow: 'hidden',
    },
});

export const NavigationHeader: React.FC<{
    locationName?: string;
    siteName: string;
    connectedDevice: string;
    device: string;
    for: string;
}> = (props) => {
    const classes = useStyles();
    const selectedOrganization = useSelectedOrganizationData();
    const selectedLocation = useSelectedLocationData();

    const location = props.locationName
        ? props.locationName
        : isRecordFound(selectedLocation)
        ? selectedLocation.value.name
        : '';

    return (
        <Box display="flex" justifyContent="flex-start" style={{ padding: 8, marginBottom: 48, width: '100%' }}>
            {isRecordFound(selectedOrganization) && (
                <>
                    <div style={{ display: 'inline', marginLeft: 3 }}>
                        <Typography
                            display="inline"
                            variant="body1"
                            noWrap
                            style={{ fontWeight: props.for === 'organization' ? 600 : 500 }}
                            className={selectedOrganization.value.name.length > 50 ? classes.wrapText : ''}
                        >
                            {selectedOrganization.value.name}{' '}
                        </Typography>

                        <Typography variant="body2" display="block">
                            Organization
                        </Typography>
                    </div>
                    {location !== '' && (
                        <>
                            <NavigateNextIcon style={{ margin: '3px 5px' }} />
                            <div
                                style={{
                                    display: 'inline',
                                    width: `${location.length > 50 ? '40%' : ''}`,
                                }}
                            >
                                <Typography
                                    display="inline"
                                    variant="body1"
                                    noWrap
                                    style={{ fontWeight: props.for === 'location' ? 600 : 500 }}
                                    className={location.length > 50 ? classes.wrapText : ''}
                                >
                                    {location}{' '}
                                </Typography>
                                <Typography variant="body2" display="block">
                                    Location
                                </Typography>
                            </div>
                        </>
                    )}
                    {props.siteName !== '' && (
                        <>
                            <NavigateNextIcon style={{ margin: '3px 5px' }} />
                            <div style={{ display: 'inline' }}>
                                <Box>
                                    <Typography
                                        display="inline"
                                        variant="body1"
                                        style={{ fontWeight: props.for === 'site' ? 600 : 500 }}
                                        className={props.siteName.length > 50 ? classes.wrapText : ''}
                                    >
                                        {props.siteName}{' '}
                                    </Typography>
                                </Box>
                                <Typography variant="body2" display="block">
                                    Site
                                </Typography>
                            </div>
                        </>
                    )}
                    {props.connectedDevice !== '' && (
                        <>
                            <NavigateNextIcon style={{ margin: '3px 5px' }} />
                            <div>
                                <Typography
                                    display="inline"
                                    variant="body1"
                                    style={{ fontWeight: props.for === 'Connected Device' ? 600 : 500 }}
                                    className={props.siteName.length > 50 ? classes.wrapText : ''}
                                >
                                    {' '}
                                    {props.connectedDevice}{' '}
                                </Typography>
                                <Typography variant="body2" display="block">
                                    Connected Device
                                </Typography>
                            </div>
                        </>
                    )}
                    {props.device !== '' && (
                        <>
                            <NavigateNextIcon style={{ margin: '3px 5px' }} />

                            <div style={{width:245}}>
                                <Typography
                                    display="inline"
                                    variant="body1"
                                    style={{wordWrap: "break-word", fontWeight: props.for === 'device' ? 600 : 500 }}
                                    className={props.siteName.length > 50 ? classes.wrapText : ''}
                                >
                                    {' '}
                                    {props.device}{' '}
                                </Typography>
                                
                                <Typography variant="body2" display="block">
                                    Device
                                </Typography>
                            </div>
                        </>
                    )}
                </>
            )}
        </Box>
    );
};
